
import main from '../../main'
import Home from './home'
import createRouter from "../../router"

main({
  loadingPath: require('./ma78-loading.jpg'),
  router: createRouter({
    Home,
    Stream: () => import('./stream')
  })
})



// WEBPACK FOOTER //
// ./src/entries/ma78/index.js